const enumLocales = {
  "en": "English",
  "es": "Spanish",
  "de": "German",
  "pt": "Portuguese"
};

export default enumLocales